import React, { useContext, useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";

import { Alert, Badge, Button, Card, Col, Container, Row, Table } from "react-bootstrap";

import useAppDispatch from "../../hooks/useAppDispatch";
import { useDeleteCompanyByIdMutation, useGetCompanyByIdQuery, useGetCompaniesQuery } from "../../redux/slices/companiesSlice";
import useAppSelector from "../../hooks/useAppSelector";
import { Company } from "../../types/company";
import PaginationTable from "../../components/PaginationTable";
import dayjs from "dayjs";
import LoadingAlert from "../../components/LoadingAlert";
import ErrorAlert from "../../components/ErrorAlert";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CheckCircle, Edit2, ExternalLink, Eye, PlusCircle, Target, Trash2, X } from "react-feather";
import { selectCurrentUser } from "../../redux/slices/authSlice";
import NotyfContext from "../../contexts/NotyfContext";
import { CustomFilterMethod, SelectChildColumnFilter, SelectColumnFilter } from "../../components/FilterTypes";

type CategoryType = {
  name: string,
  _id: string,
}

const Companies = ({ admin }: { admin: boolean }) => {


  const navigate = useNavigate();
  const notyf = useContext(NotyfContext);

  let dummy;
  const { data: companies, isLoading: isLoadingCompanies, isSuccess: isSuccessCompanies, isError: isErrorCompanies, error: errorCompanies } = useGetCompaniesQuery(dummy, {
    refetchOnMountOrArgChange: true
  });

  let content;

  const [deleteCompany, { isLoading: isLoadingDelete, isSuccess: isSuccessDelete, isError: isErrorDelete, error: errorDelete }] = useDeleteCompanyByIdMutation();


  let tableColumns = React.useMemo<any>(() => [
    {
      Header: 'Name',
      accessor: 'tradingAs',
    },
    {
      Header: 'Website',
      accessor: 'website',
      Filter: false,
      // @ts-ignore
      Cell: ({ cell: { value } }) => <a href={`https://${value}`} target="_blank" style={{ textDecoration: 'none', color: 'inherit' }}>Click Here {" "}<Button size="sm" variant="outline-none" className="btn-pill me-1 mb-1"><ExternalLink size={14} /></Button></a>
    },
    {
      Header: 'Category',
      // accessor: 'category',
      accessor: (data: { category: CategoryType[] }) => {
        const output: string[] = [];
        data.category.map((c) => {
          // console.log('c', c);
          return output.push(c?.name);
        })
        let newSet = [...new Set(output)];
        return newSet;
      },
      Filter: SelectColumnFilter,
      filter: 'include',
      //@ts-ignore
      Cell: ({ cell: { value } }) => value.map((name: string, i: number) => (
        <li key={i}>{name}</li>
      ))
    },
    {
      Header: 'Industries',
      accessor: (data: { industries: any[] }) => {
        const output: string[] = [];
        data.industries.map((c) => {
          return output.push(c?.industryId?.name);
        })
        let newSet = [...new Set(output)]
        return newSet;
      },
      Filter: SelectColumnFilter,
      filter: 'include',
      //@ts-ignore
      Cell: ({ cell: { value } }) => value.map((name: string, i: number) => (
        <li key={i}>{name}</li>
      ))
    },
    {
      Header: 'Sub-Industries',
      accessor: (data: { subIndustries: any[] }) => {
        const output: string[] = [];
        data.subIndustries.map((c) => {
          return output.push(c?.industryId?.name);
        })
        let newSet = [...new Set(output)];
        return newSet;
      },
      Filter: SelectColumnFilter,
      filter: 'include',
      //@ts-ignore
      Cell: ({ cell: { value } }) => value.map((name: string, i: number) => (
        <li key={i}>{name}</li>
      ))
    },
    {
      Header: 'Capabilities (v1.0)',
      accessor: (data: { capabilities: any[] }) => {
        const output: string[] = [];
        data.capabilities.map((c) => {
          return output.push(c?.capabilityId?.name);
        })
        let newSet = [...new Set(output)];
        return newSet;
      },
      Filter: SelectColumnFilter,
      filter: 'include',
      //@ts-ignore
      Cell: ({ cell: { value } }) => value.map((name: string, i: number) => (
        <li key={i}>{name}</li>
      ))
    },
    {
      Header: 'Region',
      accessor: 'region',
      Filter: SelectColumnFilter,
      filter: 'include',
      // //@ts-ignore
      // Cell: ({ cell: { value } }) => value ? value : 'Other'
    },
    {
      Header: 'Actions',
      accessor: '_id',
      Filter: false,
      //@ts-ignore
      Cell: ({ cell: { value } }) => {
        return (
          isLoadingDelete ? <LoadingAlert title="Is Loading..." /> : (
            <Row>
              {admin ? (
                <>

                  <Row style={{ marginLeft: '1%' }}>
                    <Button className="btn-pill mb-1" size="sm" onClick={() => navigate(`/admin/companies/company/${value}`)}><Eye size={16} /></Button>
                    <Col className="mb-1">
                    </Col>
                  </Row>
                  <Row style={{ marginLeft: '1%' }}>
                    <Button className="btn-pill mb-1" size="sm" variant="warning" onClick={() => navigate(`/admin/companies/company/${value}/edit`)}><Edit2 size={16} /></Button>
                  </Row>
                  <Row style={{ marginLeft: '1%' }}>
                    <Button className="btn-pill mb-1" size="sm" variant="danger" onClick={() => deleteCompany(value)}><Trash2 size={16} /></Button>
                  </Row>
                </>
              ) : (
                <Col className="mb-1">
                  <Button disabled className="btn-pill" size="sm" onClick={() => navigate(`/companies/company/${value}`)}><Eye size={16} /></Button>
                </Col>
              )
              }
            </Row >
          )
        )
      }
    }

  ], [])

  if (isSuccessDelete) {
    notyf.open({
      message: 'Deleted Customer Successfully!',
      type: 'success',
      dismissible: true,
      ripple: true,
      duration: 2500,
      position: {
        x: 'right',
        y: 'top'
      }
    })
  }

  if (isErrorDelete) {
    notyf.open({
      message: `Deleted Customer failed! ${errorDelete ? JSON.stringify(errorDelete, null, 2) : `Something went wrong`} `,
      type: 'danger',
      dismissible: true,
      ripple: true,
      duration: 5000,
      position: {
        x: 'right',
        y: 'top'
      }
    })
  }

  if (isLoadingCompanies) {
    content = (
      <>
        <LoadingAlert title={isLoadingCompanies ? 'Loading Companies...' : 'Loading...'} />
      </>
    )
  } else if (isSuccessCompanies && companies) {

    let sortedCompanies = companies && companies.flat().sort((a, b) => a?.name.localeCompare(b?.name));

    content = (
      <React.Fragment>
        <Card.Header>
          <Row className="mb-2 mb-xl-3">
            <Col xs="auto" className="d-none d-sm-block">
              {admin ? (
                <Card.Title>Admin - Companies</Card.Title>
              ) : (
                <Card.Title>Companies</Card.Title>
              )}
            </Col>
            <Col xs="auto" className="ms-auto text-end mt-n1">
              {admin ? (
                <Button variant="primary" className="shadow-sm" onClick={() => navigate(`/admin/companies/create`)}>
                  <PlusCircle size={18} /> {" "}
                  New Company
                </Button>
              ) : null}
            </Col>
          </Row>
        </Card.Header>
        <Row>
          <Col xl="12">
            {/* //@ts-ignore */}
            <PaginationTable columns={tableColumns} data={sortedCompanies ? sortedCompanies : []} usePageSize={20} />
          </Col>

        </Row>
      </React.Fragment >
    )
  } else if (isErrorCompanies) {
    content = (
      <>
        <ErrorAlert title={errorCompanies ? 'Error Loading Companies...' : 'Error!'} error={errorCompanies ? JSON.stringify(errorCompanies) : 'Unknown Error!'} />
      </>
    )
  } else {
    content = (
      <>
        <LoadingAlert title="Loading..." />
      </>
    )
  }

  return content;
};

export default Companies;
